import styled from 'styled-components/macro'
import { colors } from 'styled/theme.styled'

export const Root = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  > .Content {
    width: 100%;
    max-width: 400px;
    background-color: ${colors.white};
    color: ${colors.darkBlue};
    border-radius: 16px;
    margin-bottom: 24px;

    .Inner {
      padding: 48px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
    }

    h3 {
      text-transform: capitalize;
      text-align: center;
      margin-bottom: 24px;
      font-size: 24px;
      font-weight: normal;
    }

    p {
      font-size: 10px;
      line-height: 1.5;
      margin-bottom: 40px;
    }
  }
`

export const CloseButton = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: 64px;
  height: 64px;
  border-radius: 999px;
  border: 1px solid ${colors.faintBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.darkBlue};

  svg {
    width: 16px;
    fill: currentColor;
  }

  &:hover {
    cursor: pointer;
  }
`
